const { isEmptyObject } = require('utilities/common');

export function storeValidation(fields) {

    const errors = {};

    if (!fields.email || !isValidEmail(fields.email)) {
        errors.email = 'Email is required';
    }

    if (!fields.phone) {
        errors.phone = 'Mobile number is required';
    }

    if (fields?.phone && !isPhoneNumberValid(fields?.phone)) {
        errors.phone = 'Mobile number must be 10 digits';
    }

    if (!fields.firstName || fields.firstName.trim() === '') {
        errors.firstName = 'First name is required';
    }

    if (!fields.lastName || fields.lastName.trim() === '') {
        errors.lastName = 'Last name is required';
    }

    if (!fields.storeName || fields.storeName.trim() === '') {
        errors.storeName = 'Store name is required';
    }

    // if (!fields.address) {
    //     errors.address = 'Address is required';
    // }
    if (!fields?.address.address) {
        errors.address = 'Address is required';
    }
    if (!fields.address) {
        errors.address = 'Address is required';
    } else {
        // Check all address sub-fields
        const address = fields.address;
        if (!address.city) errors.city = 'City is required';
        if (!address.state) errors.state = 'State is required';
        if (!address.zipcode) errors.zipcode = 'Zipcode is required';
        // You might also want to validate lat/long if needed
    }
    if (!fields.uploadedKML) {
        errors.uploadedKML = 'Kml file is required';
    }

    // if (!fields.subscription || typeof fields.subscription !== 'string') {
    //     errors.subscription = 'Subscription information is required';
    // }

    //     if (!fields.isLifeTime) {
    //     if (!fields.valiDateFrom || !fields.valiDateTo) {
    //         if (fields.subscription !== 'Unpaid' )
    //         errors.validUpto = 'Valid upto is required';
    //     }
    // }

    return { errors, isValid: isEmptyObject(errors) };
}

export function isValidZipcode(zipcode) {
    const zipcodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;
    return zipcodeRegex.test(zipcode);
}

export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function isValidPhone(phone) {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phone);
}



function isPhoneNumberValid(phoneNumber) {
    // Remove all non-digit characters
    const cleanedPhoneNumber = phoneNumber.replace(/\D/g, '');

    // Check if the cleaned phone number has a length of 10
    return cleanedPhoneNumber.length === 10;
}